import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "@ag-grid-community/react";
import { useMaster } from "../../Hooks/Features/MasterConfiguration/useMaster";
import CommanDialog from "../CommonCompo/CommanDialog/CommanDialog";
import { SkeletonDataTable } from "../Loader/Loader";
import { useCommon } from "../../Hooks/Common/useCommon";

function Master(props) {
  const { gridApiRef, gridRef, addNewRecord, rowData, columnDefs, loader, showDelete, setshowDelete, handleDeleteTableEntityData, currentData, onCellValueChanged, getExcelDownload, tagRef, onFilterTextBoxChanged ,setFilterText} = useMaster(props);
  const { checkPermission } = useCommon();

  return (
    <div>

      <div className="d-flex justify-content-between">
        <div className="d-flex gap-4">
          <h4>{props.currentSelectedMaster.display_name}</h4>
          <div className='w30'>
            <input
              type="text"
              id="filter-text-box"
              placeholder="Filter..."
              onChange={(e)=>setFilterText(e.target.value)}
              className='widgets-input'
            />
          </div>
        </div>
        <div className="d-flex  align-items-center gap-2">
          <div ref={() => checkPermission("master config", tagRef)}>
            <button
              ref={tagRef}
              id='{"tabname": "master config", "data": "master_configuration_excel_btn"}'
              className="btn btn-default"
              onClick={getExcelDownload}
              title="Download Excel"
            >
              <FontAwesomeIcon
                icon="fa-solid fa-file-arrow-down"
              />
            </button>
          </div>
          <div>
            <button onClick={addNewRecord}>  <FontAwesomeIcon icon="fa-solid fa-plus" /> Row</button>
          </div>
          {props.Button}
        </div>
      </div>
      <h6>Total: {rowData.length}</h6>
      <div className="row">
        <div className="col-md-12 col-12">
          <div className="ag-theme-alpine new-game-container aggrid-container master-grid">
            {loader ? (
              <SkeletonDataTable numSkeletons={15} />
            ) : (
              <AgGridReact
                columnDefs={columnDefs}
                rowData={rowData?.filterData}
                ref={gridRef}
                rowHeight={24}
                headerHeight={30}
                onCellFocused={onCellValueChanged}
                onGridReady={(params) => {
                  gridApiRef.current = params.api;
                }}
              />
            )}
          </div>
        </div>
      </div>

      <CommanDialog
        visible={showDelete}
        message={"Are You Sure You Want to delete it?"}
        handleClose={() => setshowDelete(false)}
        handleFun={() => {
          setshowDelete(false);
          handleDeleteTableEntityData(currentData.current);
        }}
      />
    </div>
  );
}

export default Master;
